import { render } from "./Spinner.vue?vue&type=template&id=205ea7c7"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import exportComponent from "C:\\repos\\CharitableBail\\CT.PublicAccess.CharitableBail.UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__